const REQUEST_GET_REPORT = 'REQUEST_GET_REPORT'
const UPDATE_GET_REPORT = 'UPDATE_GET_REPORT'
const RESPONSE_GET_REPORT = 'RESPONSE_GET_REPORT'
const REQUEST_GET_REPORT_FAILURE = 'REQUEST_GET_REPORT_FAILURE'
const RESPONSE_TO_INITIAL_STATE = 'RESPONSE_TO_INITIAL_STATE'


const getReportStateAction = (queryItems) => {
  return {
    type: REQUEST_GET_REPORT,
    queryItems,
  }
}

const getReportState = (queryItems) => {
  return (dispatch) => {
    dispatch(getReportStateAction(queryItems))
  }
}

const updateGetReportStateAction = (queryItems) => {
  return {
    type: UPDATE_GET_REPORT,
    queryItems,
  }
}

const updateGetReportState = (queryItems) => {
  return (dispatch) => {
    dispatch(updateGetReportStateAction(queryItems))
  }
}


const getReporSuccesstStateAction = () => {
  return {
    type: RESPONSE_GET_REPORT,
  }
}

const getReporSuccesstState = () => {
  return (dispatch) => {
    dispatch(getReporSuccesstStateAction())
  }
}


const getReporFailuretStateAction = () => {
  return {
    type: REQUEST_GET_REPORT_FAILURE,
  }
}

const getReporFailuretState = () => {
  return (dispatch) => {
    dispatch(getReporFailuretStateAction())
  }
}

const responseClearReportStateAction = () => {
  return {
    type: RESPONSE_TO_INITIAL_STATE,
  }
}
const clearReportState = () => {
  return (dispatch) => {
    dispatch(responseClearReportStateAction())
  }
}


export {
  getReportState,
  updateGetReportState,
  getReporSuccesstState,
  getReporFailuretState,
  clearReportState,

  getReportStateAction,
  updateGetReportStateAction,
  getReporSuccesstStateAction,
  getReporFailuretStateAction,
  responseClearReportStateAction,

  REQUEST_GET_REPORT,
  UPDATE_GET_REPORT,
  RESPONSE_GET_REPORT,
  REQUEST_GET_REPORT_FAILURE,
  RESPONSE_TO_INITIAL_STATE,

}
